/* eslint-disable import/prefer-default-export */
import { computed } from 'vue';
import { useQuantity } from '@modules/product';
import { useTraits } from '@composables/useTraits';
import { useUpc, useUpcValidator } from '@modules/upc';
import { useProductPrice } from '@modules/price/composables';
/**
 * * Add To Registry Payload
 *
 * @description
 * Prepares the Add To Registry payload data
 */
export const useATRPayload = () => {
  const { upcValidator } = useUpcValidator();
  const { selectedUpcId, selectedUpcNumber } = useUpc();
  const { selectedSize, selectedColor } = useTraits();
  const { quantity } = useQuantity();
  const selectedPrice = useProductPrice();
  const { lowestSalePriceTier, tieredPrice } = selectedPrice.value;
  const lowestPrice = lowestSalePriceTier?.values?.[0]?.value;
  const originalPrice = tieredPrice?.[0]?.values?.[0]?.value;

  /**
   * * Add To Registry Payload
   *
   * @description
   * Add To Registry payload data
   * You can add or remove payload data here
   *
   * @type {import('vue').ComputedRef<AddToRegistryPayload>}
   */
  const payload = computed(() => ({
    // Add or remove Add To Registry payload data here
    selectedUpcId: selectedUpcId.value,
    upcNumber: selectedUpcNumber.value,
    selectedColor: selectedColor.value?.name,
    selectedSize: selectedSize.value?.displayName,
    quantity: quantity.value,
    price: lowestPrice,
    originalPrice,
    totalPrice: quantity.value * lowestPrice,
  }));

  /**
   * * Add To Registry Payload Validator
   * You could change the validator to match your needs
   * @type {AddToRegistryValidator}
   */
  const payloadValidator = upcValidator;

  return {
    payload,
    payloadValidator,
  };
};
